import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: 'pusher',
  wssHost: process.env.VUE_APP_WS,
  key: '45402af9ae1440210f0e',
  cluster: 'ap2',
  wsHost: process.env.VUE_APP_WS,
  wsPort: 6001,
  encrypted: true,
  forceTLS: true,
  authEndpoint: `https://${process.env.VUE_APP_WS}/api/broadcasting/auth`,
  auth: {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.access_token}`
    }
  }
})
